export default __webpack_public_path__ + "static/media/table-tablet.2d9ad8d6.png";